module.exports = __webpack_public_path__ + "static/mobile-mock-web-8fa02bf2d78d9b44d08cfb4a4384936f.svg";